var keyMirror = require('keymirror');

module.exports = keyMirror({
  PASSWORD_RESET_REQUEST: null
});